import { OrderHistoryAction } from "../types/enums";

interface OrderHistoryItemProps {
  history: {
    id?: string;
    createdAt: string | Date;
    status?: string;
    action?: string;
    details?: {
      oldDate?: string | null;
      newDate?: string;
      oldStatus?: string;
    };
    user?: {
      firstName?: string;
      lastName?: string;
    };
  };
}

export const OrderHistoryItem = ({ history }: OrderHistoryItemProps) => {
  return (
    <div key={history?.id ?? `${history?.createdAt}-${history?.status}`}>
      {new Date(history?.createdAt).toLocaleString()} -{" "}
      <strong>{history?.status || history?.action}</strong>
      {history?.action === OrderHistoryAction.BOT_UPDATE &&
        history?.details?.oldStatus && (
          <span>&nbsp;From {history.details.oldStatus}</span>
        )}
      {history?.action === OrderHistoryAction.DELIVERY_DATE_UPDATED &&
        history?.details && (
          <span>
            {" "}
            (from{" "}
            {history.details.oldDate
              ? new Date(history.details.oldDate).toLocaleDateString()
              : "N/A"}{" "}
            to {new Date(history.details.newDate).toLocaleDateString()})
          </span>
        )}
      {history?.action === OrderHistoryAction.BOT_UPDATE &&
        ` - Auto-updated by BOT`}
      {history?.user?.firstName &&
        ` - Updated by ${history?.user?.firstName} ${history?.user.lastName ?? ""}`}
    </div>
  );
};
